import styles from './text-field.module.scss';
import clsx from 'clsx';
import { FieldStatus } from '../form.types';
import { MaskedInput } from 'antd-mask-input';
import { MaskType, MaskedInputProps } from 'antd-mask-input/build/main/lib/MaskedInput';
import { Divider, Input } from 'antd';
import { UnitLocation } from './text-field.types';

interface TextFieldProps extends Omit<MaskedInputProps, 'status' | 'mask'> {
  status?: FieldStatus;
  mask?: MaskType;
  units?: string | number;
  unitsLocation?: UnitLocation;
}

export default function TextField({
  status,
  disabled,
  mask = /./gm,
  suffix,
  prefix,
  units,
  unitsLocation,
  type = 'text',
  ...restProps
}: TextFieldProps) {
  return type === 'password' ? (
    <Input.Password
      {...restProps}
      className={clsx(
        styles.textField,
        status && styles[`textField-${status}`],
        disabled && styles['textField-disabled']
      )}
      disabled={disabled}
      variant="borderless"
    />
  ) : (
    <MaskedInput
      {...restProps}
      mask={mask}
      suffix={
        suffix && (
          <>
            <Divider className={styles.textFieldDivider} type="vertical" />
            {unitsLocation && unitsLocation.match(/^(suffix|both)/) ? (
              <span className={styles.units}>{units}</span>
            ) : (
              suffix
            )}
          </>
        )
      }
      prefix={
        prefix && (
          <>
            {unitsLocation && unitsLocation.match(/^(prefix|both)/) ? (
              <span className={styles.units}>{units}</span>
            ) : (
              prefix
            )}
            <Divider className={styles.textFieldDivider} type="vertical" />
          </>
        )
      }
      disabled={disabled}
      className={clsx(
        styles.textField,
        status && styles[`textField-${status}`],
        disabled && styles['textField-disabled']
      )}
      type={type}
      variant="borderless"
    />
  );
}
